import Vue from 'vue'
import Router from 'vue-router'
import { VolunteerLogin } from '@/api/login'

Vue.use(Router)

const routes = [
  {
    path: '/',
    name: 'index',
    component: resolve => require(['@/components/Index'], resolve)
  },
  {
    path: '/enlist/:articleno',
    name: 'enlist',
    component: resolve => require(['@/components/index/EnlistForm'], resolve)
  },
  {
    path: '/login',
    name: 'login',
    component: resolve => require(['@/components/index/Login'], resolve)
  },
  {
    path: '/honour',
    name: 'honour',
    component: resolve => require(['@/components/index/Honour'], resolve)
  },
  {
    path: '/info/article/:articleno',
    name: 'article',
    component: resolve => require(['@/components/info/Article'], resolve)
  },
  {
    path: '/info/information',
    name: 'information',
    component: resolve => require(['@/components/info/Information'], resolve)
  },
  {
    path: '/volunteer/activity/:activityNo',
    name: 'activity',
    component: resolve => require(['@/components/info/ActivityDetail'], resolve)
  },
  {
    path: '/volunteer/articledetail/:articleno',
    name: 'articledetail',
    component: resolve => require(['@/components/info/ArticleDetail'], resolve)
  },
  {
    path: '/info/articlelist',
    name: 'articlelist',
    component: resolve => require(['@/components/info/ArticleList'], resolve)
  },
  {
    path: '/photowall',
    name: 'photowall',
    component: resolve => require(['@/components/index/PhotoWall'], resolve)
  },
  {
    path: '/volunteer',
    name: 'volunteer',
    meta: {
      requireAuth: true
    },
    component: resolve => require(['@/components/volunteer/Volunteer'], resolve)
  },
  {
    path: '/volunteer/expound',
    name: 'volunteer-expound',
    component: resolve =>
      require(['@/components/volunteer/VolunteerExpound'], resolve)
  },
  {
    path: '/volunteer/details',
    name: 'volunteer-details',
    component: resolve =>
      require(['@/components/volunteer/VolunteerDetails'], resolve)
  },
  {
    path: '/volunteer/activities',
    name: 'volunteer-activities',
    component: resolve =>
      require(['@/components/volunteer/VolunteerActivities'], resolve)
  },
  {
    path: '/volunteer/assess',
    name: 'exhibition-assess',
    component: resolve =>
      require(['@/components/volunteer/ExhibitionAssess'], resolve)
  },
  {
    path: '/volunteer/clothes',
    name: 'volunteer-clothes',
    component: resolve =>
      require(['@/components/volunteer/VolunteerClothes'], resolve)
  },
  {
    path: '/volunteer/comments',
    name: 'volunteer-comments',
    component: resolve =>
      require(['@/components/volunteer/VolunteerComments'], resolve)
  },
  {
    path: '/volunteer/honours',
    name: 'volunteer-honours',
    component: resolve =>
      require(['@/components/volunteer/VolunteerHonours'], resolve)
  },
  {
    path: '/volunteer/expoundlist',
    name: 'volunteer-expoundlist',
    component: resolve => require(['@/components/info/ExpoundList'], resolve)
  },
  {
    path: '/volunteer/expoundul', // 移动端/公众号
    name: 'volunteer-expoundul',
    component: resolve => require(['@/components/index/ExpoundUl'], resolve)
  },
  {
    path: '/volunteer/largeScreen', // 大屏展示
    name: 'volunteer-largeScreen',
    component: resolve => require(['@/components/index/LargeScreen'], resolve)
  },
  {
    path: '/info/indexnews',
    name: 'indexnews',
    component: resolve => require(['@/components/info/IndexNews'], resolve)
  }
]

const router = new Router({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

// 页面刷新时，重新赋值token
/* if (window.localStorage.getItem('token')) {
    store.commit(types.LOGIN, window.localStorage.getItem('token'))
} */

router.beforeEach((to, from, next) => {
  if (to.matched.some(r => r.meta.requireAuth)) {
    var storage = localStorage
    var token = storage.getItem('token')
    if (token) {
      var account = JSON.parse(storage.getItem('account'))
      var param = {}
      param.phone = account
      param.password = token
      VolunteerLogin(param).then(res => {
        var _data = res.data
        if (_data.errcode == '200') {
          next()
        } else {
          next({
            path: '/login'
          })
        }
      })
    } else {
      next({
        path: '/login'
        // query: {redirect: to.fullPath}
      })
    }
  } else {
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js